import React, {Component} from "react";
import Button from "../components/Button";
import "./LoginPage.scss";

class LoginPage extends Component {

  UNSAFE_componentWillMount() {
    this.props.checkLoggedIn(); 
  }

  render() {
    return (
      <div className="LoginPage">
        <div className="inner">
          <img
            className="logo"
            src="/images/LogoSimple-Black.svg"
            alt="Hallstein - Artesian Water"
            width={231}
            height={96}
          />
          <h1>Backoffice</h1>
          <p>This is a restricted app. You need to authenticate to proceed.</p>
          <Button label="Login" onClick={this.handleLogin.bind(this)} />
        </div>
      </div>
    )
  }

  handleLogin() {
    this.props.showLogin();
  }

}

export default LoginPage;